class NotificationCenterApi {
    constructor(DoclrHttp, praktijkContext, AppConfigService) {
        'ngInject';
        this.DoclrHttp = DoclrHttp;
        this.praktijkContext = praktijkContext;
        this.AppConfigService = AppConfigService;
    }

    getNotifications() {
        return this.DoclrHttp.get(this.AppConfigService.getApiUrl() + this._getUrl())
            .then(response => response
                .map(dto => this._mapToNotification(dto))
                .filter(n => n !== null)
            );
    }

    _getUrl() {
        return `/api/notification/v1/party/${this.praktijkContext.id}/notification-center`;
    }

    _mapToNotification(dto) {
        switch (dto.notificationType) {
            case 'AppointmentToConfirm':
                return {
                    displayValue: dto.displayValue,
                    action: {type: 'OPEN_APPOINTMENT', appointmentId: dto.appointmentId}
                };
            default:
                console.warn('Unknown notification type:', dto.notificationType);
                return null;
        }
    }
}

(function () {
    'use strict';

    angular.module('doclr.components')
        .service('NotificationCenterApi', NotificationCenterApi);

})();